import React, { lazy, Suspense, useState } from 'react';
import { Layout } from '../../components/layout/Layout';
import { Video, X, ZoomIn, Play } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

interface GalleryItem {
  id: number;
  category: string;
  type: 'image' | 'video';
  src: string;
  full: string;
  label: string;
  gradient: string;
}

const galleryItems: GalleryItem[] = [
  // Weddings
  { id: 1, category: 'weddings', type: 'image', src: '/images/gallery/1617627143750-d86bc21e42bb.webp', full: 'https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?auto=format&fit=crop&w=1200&q=80', label: 'Bridal Portrait', gradient: 'from-rose-400 to-pink-500' },
  { id: 2, category: 'weddings', type: 'image', src: '/images/gallery/1511285560929-80b456fea0bc.webp', full: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1200&q=80', label: 'Wedding Celebration', gradient: 'from-pink-400 to-fuchsia-500' },
  { id: 3, category: 'weddings', type: 'video', src: '/images/gallery/1583939003579-730e3918a45a.webp', full: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&w=1200&q=80', label: 'Confetti Moment', gradient: 'from-rose-500 to-red-500' },
  { id: 4, category: 'weddings', type: 'image', src: '/images/gallery/1597157639073-69284dc0fdaf.webp', full: 'https://images.unsplash.com/photo-1597157639073-69284dc0fdaf?auto=format&fit=crop&w=1200&q=80', label: 'Mehndi Ceremony', gradient: 'from-fuchsia-400 to-rose-500' },
  { id: 5, category: 'weddings', type: 'image', src: '/images/gallery/1606800052052-a08af7148866.webp', full: 'https://images.unsplash.com/photo-1606800052052-a08af7148866?auto=format&fit=crop&w=1200&q=80', label: 'Wedding Rings', gradient: 'from-rose-400 to-pink-600' },
  { id: 6, category: 'weddings', type: 'video', src: '/images/gallery/1587271407850-8d438ca9fdf2.webp', full: 'https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?auto=format&fit=crop&w=1200&q=80', label: 'Reception Highlights', gradient: 'from-pink-500 to-rose-600' },

  // Baby Photography
  { id: 7, category: 'baby', type: 'image', src: '/images/gallery/1544126592-807ade215a0b.webp', full: 'https://images.unsplash.com/photo-1544126592-807ade215a0b?auto=format&fit=crop&w=1200&q=80', label: 'Newborn Sleep', gradient: 'from-amber-400 to-orange-500' },
  { id: 8, category: 'baby', type: 'image', src: '/images/gallery/1491013516836-7db643ee125a.webp', full: 'https://images.unsplash.com/photo-1491013516836-7db643ee125a?auto=format&fit=crop&w=1200&q=80', label: 'Sweet Baby', gradient: 'from-orange-400 to-amber-500' },
  { id: 9, category: 'baby', type: 'image', src: '/images/gallery/1555252333-9f8e92e65df9.webp', full: 'https://images.unsplash.com/photo-1555252333-9f8e92e65df9?auto=format&fit=crop&w=1200&q=80', label: 'Tiny Toes', gradient: 'from-yellow-400 to-orange-500' },
  { id: 10, category: 'baby', type: 'image', src: '/images/gallery/1566004100631-35d015d6a491.webp', full: 'https://images.unsplash.com/photo-1566004100631-35d015d6a491?auto=format&fit=crop&w=1200&q=80', label: 'Peekaboo', gradient: 'from-amber-500 to-yellow-500' },
  { id: 11, category: 'baby', type: 'video', src: '/images/gallery/1503454537195-1dcabb73ffb9.webp', full: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=1200&q=80', label: 'Toddler Playtime', gradient: 'from-orange-400 to-red-400' },
  { id: 12, category: 'baby', type: 'image', src: '/images/gallery/1515488042361-ee00e0ddd4e4.webp', full: 'https://images.unsplash.com/photo-1515488042361-ee00e0ddd4e4?auto=format&fit=crop&w=1200&q=80', label: 'Toy Time', gradient: 'from-amber-400 to-orange-600' },

  // Pre-Wedding
  { id: 13, category: 'pre-wedding', type: 'image', src: '/images/gallery/1621621667797-e06afc217fb0.webp', full: 'https://images.unsplash.com/photo-1621621667797-e06afc217fb0?auto=format&fit=crop&w=1200&q=80', label: 'Couple Portrait', gradient: 'from-violet-400 to-purple-500' },
  { id: 14, category: 'pre-wedding', type: 'image', src: '/images/gallery/1494774157365-9e04c6720e47.webp', full: 'https://images.unsplash.com/photo-1494774157365-9e04c6720e47?auto=format&fit=crop&w=1200&q=80', label: 'Sunset Romance', gradient: 'from-purple-400 to-indigo-500' },
  { id: 15, category: 'pre-wedding', type: 'video', src: '/images/gallery/1604017011826-d3b4c23f8914.webp', full: 'https://images.unsplash.com/photo-1604017011826-d3b4c23f8914?auto=format&fit=crop&w=1200&q=80', label: 'Hilltop Romance', gradient: 'from-indigo-400 to-violet-500' },
  { id: 16, category: 'pre-wedding', type: 'image', src: '/images/gallery/1537633552985-df8429e8048b.webp', full: 'https://images.unsplash.com/photo-1537633552985-df8429e8048b?auto=format&fit=crop&w=1200&q=80', label: 'Beach Romance', gradient: 'from-violet-500 to-purple-600' },
  { id: 17, category: 'pre-wedding', type: 'image', src: '/images/gallery/1532712938310-34cb3982ef74.webp', full: 'https://images.unsplash.com/photo-1532712938310-34cb3982ef74?auto=format&fit=crop&w=1200&q=80', label: 'Golden Hour Walk', gradient: 'from-fuchsia-400 to-violet-500' },
  { id: 18, category: 'pre-wedding', type: 'image', src: '/images/gallery/1520854221256-17451cc331bf.webp', full: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=1200&q=80', label: 'Hand in Hand', gradient: 'from-purple-500 to-pink-500' },

  // Outdoor
  { id: 19, category: 'outdoor', type: 'image', src: '/images/gallery/1476514525535-07fb3b4ae5f1.webp', full: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=1200&q=80', label: 'Mountain Lake', gradient: 'from-emerald-400 to-teal-500' },
  { id: 20, category: 'outdoor', type: 'image', src: '/images/gallery/1506905925346-21bda4d32df4.webp', full: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=format&fit=crop&w=1200&q=80', label: 'Above the Clouds', gradient: 'from-teal-400 to-cyan-500' },
  { id: 21, category: 'outdoor', type: 'video', src: '/images/gallery/1586348943529-beaae6c28db9.webp', full: 'https://images.unsplash.com/photo-1586348943529-beaae6c28db9?auto=format&fit=crop&w=1200&q=80', label: 'Sunset Lake', gradient: 'from-cyan-400 to-blue-500' },
  { id: 22, category: 'outdoor', type: 'image', src: '/images/gallery/1501854140801-50d01698950b.webp', full: 'https://images.unsplash.com/photo-1501854140801-50d01698950b?auto=format&fit=crop&w=1200&q=80', label: 'Green Hills', gradient: 'from-green-400 to-emerald-500' },
  { id: 23, category: 'outdoor', type: 'image', src: '/images/gallery/1460978812857-470ed1c77af0.webp', full: 'https://images.unsplash.com/photo-1460978812857-470ed1c77af0?auto=format&fit=crop&w=1200&q=80', label: 'Windswept Vows', gradient: 'from-emerald-500 to-teal-600' },
  { id: 24, category: 'outdoor', type: 'image', src: '/images/gallery/1441974231531-c6227db76b6e.webp', full: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1200&q=80', label: 'Forest Light', gradient: 'from-teal-500 to-green-600' },
];

// Headless UI is only needed once a photo is opened.
const Modal = lazy(() => import('../../components/ui/Modal').then((m) => ({ default: m.Modal })));

const ACTIVE_COLORS: Record<string, string> = {
  all: 'linear-gradient(135deg, #d946ef, #7c3aed)',
  weddings: 'linear-gradient(135deg, #f43f5e, #db2777)',
  baby: 'linear-gradient(135deg, #f59e0b, #ea580c)',
  'pre-wedding': 'linear-gradient(135deg, #8b5cf6, #6d28d9)',
  outdoor: 'linear-gradient(135deg, #10b981, #0e7490)',
};

const categories = [
  { id: 'all', name: 'All Works' },
  { id: 'weddings', name: 'Weddings' },
  { id: 'baby', name: 'Baby Photography' },
  { id: 'pre-wedding', name: 'Pre-Wedding' },
  { id: 'outdoor', name: 'Outdoor' },
];

export const GalleryPage: React.FC = () => {
  const [selectedItem, setSelectedItem] = useState<GalleryItem | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  const filteredItems = selectedCategory === 'all'
    ? galleryItems
    : galleryItems.filter(item => item.category === selectedCategory);

  return (
    <Layout>
      {/* Hero Section */}
      <section
        className="relative text-white py-20 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #4c1d95 0%, #701a75 40%, #9d174d 70%, #881337 100%)' }}
      >
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-0 w-64 h-64 rounded-full blur-3xl opacity-25" style={{ background: '#f0abfc' }} />
          <div className="absolute bottom-0 right-0 w-64 h-64 rounded-full blur-3xl opacity-20" style={{ background: '#fda4af' }} />
        </div>
        <div className="h-1 absolute top-0 left-0 right-0 bg-gradient-to-r from-primary-400 via-rose-400 via-amber-400 to-emerald-400" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={false}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-4">
              Our{' '}
              <span className="bg-clip-text text-transparent" style={{ backgroundImage: 'linear-gradient(90deg, #fda4af, #fcd34d, #a7f3d0)' }}>
                Gallery
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-purple-200 max-w-3xl mx-auto">
              Explore our collection of beautiful moments captured through our lens
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-5 border-b border-primary-100 sticky top-16 z-40" style={{ background: 'rgba(253,244,255,0.96)', backdropFilter: 'blur(16px)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => {
              const isActive = selectedCategory === category.id;
              return (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-5 py-2 rounded-full font-semibold transition-all duration-200 text-sm hover:scale-105 ${
                    isActive
                      ? 'text-white shadow-lg scale-105'
                      : 'bg-white text-gray-600 shadow border border-gray-200 hover:border-primary-200 hover:shadow-md'
                  }`}
                  style={isActive ? { background: ACTIVE_COLORS[category.id] } : {}}
                >
                  {category.name}
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-12 relative" style={{ background: 'linear-gradient(180deg, #fdf4ff 0%, #fae8ff 60%, #fdf4ff 100%)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <AnimatePresence mode="popLayout" initial={false}>
            <motion.div
              key={selectedCategory}
              layout
              className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
            >
              {filteredItems.map((item, index) => (
                <motion.div
                  key={item.id}
                  layout
                  initial={{ opacity: 0, scale: 0.85 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.85 }}
                  transition={{ duration: 0.3, delay: index * 0.025 }}
                  whileHover={{ scale: 1.05, zIndex: 10 }}
                  className="aspect-square rounded-2xl overflow-hidden shadow-lg cursor-pointer relative group"
                  onClick={() => setSelectedItem(item)}
                >
                  <img
                    src={item.src}
                    alt={item.label}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    width={400}
                    height={400}
                    loading={index < 4 ? 'eager' : 'lazy'}
                    fetchPriority={index < 4 ? 'high' : 'auto'}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const fallback = target.nextSibling as HTMLElement;
                      if (fallback) fallback.classList.remove('hidden');
                    }}
                  />
                  {/* Gradient fallback */}
                  <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} hidden items-center justify-center`}>
                    {item.type === 'video' ? (
                      <Video className="h-12 w-12 text-white opacity-60" />
                    ) : (
                      <ZoomIn className="h-12 w-12 text-white opacity-60" />
                    )}
                  </div>
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
                      <p className="text-white text-xs font-semibold">{item.label}</p>
                      <div className="w-8 h-8 rounded-full bg-white/90 flex items-center justify-center shadow-md flex-shrink-0">
                        {item.type === 'video'
                          ? <Play className="h-4 w-4 text-violet-600 ml-0.5" />
                          : <ZoomIn className="h-4 w-4 text-primary-600" />
                        }
                      </div>
                    </div>
                  </div>
                  {/* Video badge */}
                  {item.type === 'video' && (
                    <div className="absolute top-2 left-2 bg-black/60 backdrop-blur-sm rounded-full px-2 py-0.5 flex items-center gap-1">
                      <Video className="h-3 w-3 text-white" />
                      <span className="text-white text-xs font-medium">Video</span>
                    </div>
                  )}
                  {/* Shine */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 55%)' }} />
                </motion.div>
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedItem && (
          <Suspense fallback={null}>
          <Modal isOpen={true} onClose={() => setSelectedItem(null)} size="xl" title="">
              <div className="relative">
                <button
                  onClick={() => setSelectedItem(null)}
                  className="absolute -top-2 -right-2 z-20 bg-white rounded-full p-2 shadow-xl hover:scale-110 transition-transform border border-gray-100"
                >
                  <X className="h-5 w-5 text-gray-700" />
                </button>
  
                <div className="rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src={selectedItem.full}
                    alt={selectedItem.label}
                    className="w-full object-cover max-h-[70vh]"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const fallback = target.nextSibling as HTMLElement;
                      if (fallback) fallback.classList.remove('hidden');
                    }}
                  />
                  <div className={`w-full h-80 bg-gradient-to-br ${selectedItem.gradient} hidden items-center justify-center`}>
                    {selectedItem.type === 'video'
                      ? <Play className="h-20 w-20 text-white opacity-60" />
                      : <ZoomIn className="h-20 w-20 text-white opacity-60" />
                    }
                  </div>
                </div>
  
                <div className="mt-4 px-1 flex items-center justify-between">
                  <div>
                    <h3 className="font-bold text-gray-900 text-lg">{selectedItem.label}</h3>
                    <p className="text-sm text-gray-500 capitalize">{selectedItem.category.replace('-', ' ')} · {selectedItem.type}</p>
                  </div>
                  <span
                    className="px-3 py-1 rounded-full text-white text-xs font-semibold capitalize shadow"
                    style={{ background: ACTIVE_COLORS[selectedItem.category] || ACTIVE_COLORS.all }}
                  >
                    {selectedItem.category.replace('-', ' ')}
                  </span>
                </div>
              </div>
            </Modal>
          </Suspense>
        )}
      </AnimatePresence>
    </Layout>
  );
};
